import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPSupplierActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				menu="AP09"
				name="FinanceAPSupplier"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPSupplier"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPSupplierActivity)
